import { AutomatedVehicleReminderInfoTimeframeEnum } from '../../sdk'

export function getTimeframeStartEnd(
  timeframe: AutomatedVehicleReminderInfoTimeframeEnum
): [Date, Date] {
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  let start, end

  switch (timeframe) {
    case AutomatedVehicleReminderInfoTimeframeEnum.LastMonth:
      start = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate())
      end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
      break
    case AutomatedVehicleReminderInfoTimeframeEnum.Last2Weeks:
      start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 14)
      end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
      break
    case AutomatedVehicleReminderInfoTimeframeEnum.LastWeek:
      start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7)
      end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
      break
    case AutomatedVehicleReminderInfoTimeframeEnum.NextWeek:
      start = new Date(now)
      end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7)
      break
    case AutomatedVehicleReminderInfoTimeframeEnum.Next2Weeks:
      start = new Date(now)
      end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 14)
      break
    case AutomatedVehicleReminderInfoTimeframeEnum.NextMonth:
      start = new Date(now)
      end = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate())
      break
  }
  return [start, end]
}
